import React, { useState } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";

interface Plan {
  details: string;
  planType: string;
  gimmick: string;
  energyCharge: string;
  rates: {
    "500kWh": string;
    "1000kWh": string;
    "2000kWh": string;
  };
  baseCharge: string;
  usageFee: string;
  etf: string;
  billCredit: string;
}

const DefaultPlan: Plan = {
  details: "Plan A",
  planType: "Fixed",
  gimmick: "None",
  energyCharge: "0.08 ¢/kWh",
  rates: {
    "500kWh": "0.08 ¢/kWh",
    "1000kWh": "0.08 ¢/kWh",
    "2000kWh": "0.08 ¢/kWh",
  },
  baseCharge: "None",
  usageFee: "None",
  etf: "$20/mo",
  billCredit: "None",
};

const GridData = ({ plan1, plan2 }) => {
  const [plans, setPlans] = useState<Plan[]>([]);

  const theme = createTheme({
    typography: {
      fontFamily: "'Futura PT Book', sans-serif",
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ margin: "20px" }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Details</TableCell>
                <TableCell>Gimmick</TableCell>
                <TableCell>Energy Charge</TableCell>
                <TableCell>500 kWh</TableCell>
                <TableCell>1000 kWh</TableCell>
                <TableCell>2000 kWh</TableCell>
                <TableCell>Base Charge</TableCell>
                <TableCell>Usage Fee</TableCell>
                <TableCell>ETF</TableCell>
                <TableCell>Bill Credit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plan1 && plan2 ? (
                <>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography fontWeight="bold">Plan A</Typography>
                    </TableCell>
                    <TableCell>{plan1.gimmick}</TableCell>
                    <TableCell>{plan1.energyCharge}</TableCell>
                    <TableCell>{plan1.rates["500kWh"]}</TableCell>
                    <TableCell>{plan1.rates["1000kWh"]}</TableCell>
                    <TableCell>{plan1.rates["2000kWh"]}</TableCell>
                    <TableCell>{plan1.baseCharge}</TableCell>
                    <TableCell>{plan1.usageFee}</TableCell>
                    <TableCell>{plan1.etf}</TableCell>
                    <TableCell>{plan1.billCredit}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      <Typography fontWeight="bold">Plan B</Typography>
                    </TableCell>
                    <TableCell>{plan2.gimmick}</TableCell>
                    <TableCell>{plan2.energyCharge}</TableCell>
                    <TableCell>
                      {Number(plan2.rates["500kWh"]).toFixed(2)}¢
                    </TableCell>
                    <TableCell>
                      {Number(plan2.rates["1000kWh"]).toFixed(2)}¢
                    </TableCell>
                    <TableCell>
                      {Number(plan2.rates["2000kWh"]).toFixed(2)}¢
                    </TableCell>
                    <TableCell>{Number(plan2.baseCharge)}¢</TableCell>
                    <TableCell>{plan2.usageFee}</TableCell>
                    <TableCell>{plan2.etf}</TableCell>
                    <TableCell>{plan2.billCredit}</TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    Loading...
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </ThemeProvider>
  );
};

export default GridData;
